module.exports = __webpack_public_path__ + "static/media/detail_0053_t.35c3a9da.jpg";